



























































































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../components/left-nav.vue";
@Component({
  components: {
    MainHeader,
    LeftNav,
  },
})
export default class SzjcFolder extends Vue {
  private books: any = {
    人民卫生出版社: {
      publisher: "人民卫生出版社",
      title1: "舌的形体结构",
      title2: "",
      title3: "",
    },
    中国中医药出版社舌诊部分: {
      publisher: "中国中医药出版社舌诊部分",
      title1: "舌的形体结构",
      title2: "",
      title3: "",
    },
    中国中医药出版社面诊部分: {
      publisher: "中国中医药出版社面诊部分",
      title1: "望色",
      title2: "综述",
      title3: "",
    },
    上海科学技术出版社: {
      publisher: "上海科学技术出版社",
      title1: "舌诊概说",
      title2: "舌的形态、结构、功能",
      title3: "",
    },
  };

  /**
   * @description 跳转详情
   */
  private jumpSzjcDetail(publisher) {
    this.$router.push({
      path: "/main/szjx/szjc",
      query: this.books[publisher],
    });
  }
}
